import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import objectSupport from 'dayjs/plugin/objectSupport';
import isBetween from 'dayjs/plugin/isBetween';

import { Text, StyledCard, StyledCardContent, Avatar, ContainedButton } from '../../index';

dayjs.extend(objectSupport);
dayjs.extend(isBetween);

export const CheckInCard = ({ data, onStart, loading, disabled }) => {
    const history = useHistory();

    const handleClickPatientDetail = (id) => {
        history.push(`/provider/session/client/detail/${id}`);
    };

    return (
        <StyledCard padding="20px">
            <StyledCardContent>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Text $fontSize="18px" $bold>
                        Check In
                    </Text>
                    <Text $fontSize="14px" $color="gray2">
                        Ready{' '}
                        {`${data.filter((item) => item.checkinTime !== null).length}/${
                            data.length
                        }`}
                    </Text>
                </div>
                <div
                    style={{
                        marginTop: '15px',
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: '5px',
                        height: '340px',
                        overflowY: 'auto',
                        paddingBottom: '65px',
                    }}
                >
                    {data.map((item) => (
                        <StyledCard
                            padding="8px 12px"
                            $borderColor="gray6"
                            key={'CheckInCard' + item.id}
                            style={{ overflow: 'unset' }}
                        >
                            <StyledCardContent>
                                <div style={{ display: 'flex' }}>
                                    <Avatar
                                        alt={
                                            !item.id || !item?.user
                                                ? ''
                                                : item?.user?.fullname
                                        }
                                        src={
                                            !item.id || !item?.user
                                                ? null
                                                : item?.user?.avatar?.url
                                        }
                                        $avatarSize="48px"
                                        onClick={() => handleClickPatientDetail(item.id)}
                                        disabled={!item.id || !item?.user}
                                    />

                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            marginLeft: '8px',
                                            width: '100%',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <Text
                                            style={{ maxWidth: '200px' }}
                                            $fontSize="16px"
                                            $ellipsis
                                            $lineHeight="20px"
                                            $bold
                                            onClick={() => handleClickPatientDetail(item.id)}
                                            disabled={!item.id || !item?.user}
                                        >
                                            {!item.id || !item?.user
                                                ? 'Inactive'
                                                : item?.user?.fullname}
                                        </Text>
                                        <Text $color="gray2" $fontSize="12px">
                                            {item.checkinTime ? 'Ready' : 'not Ready'}
                                        </Text>
                                    </div>
                                </div>
                            </StyledCardContent>
                        </StyledCard>
                    ))}
                </div>
            </StyledCardContent>
            <div
                style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    padding: '15px',
                    backgroundColor: 'white',
                }}
            >
                <ContainedButton
                    $backgroundColor="green7"
                    $height="49px"
                    onClick={onStart}
                    disabled={disabled}
                    loading={loading}
                >
                    <Text $fontSize="14px" $medium $color="white">
                        Start Group Call Now
                    </Text>
                </ContainedButton>
            </div>
        </StyledCard>
    );
};

CheckInCard.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    onStart: PropTypes.func,
};
